// @flow
export const ATTEMPTS_BEFORE_FAIL = 5;
export const ATTEMPT_LOAD_COUNTRY_CONFIG = 'hive/config/ATTEMPT_LOAD_COUNTRY_CONFIG';
export const LOAD_COUNTRY_CONFIG = 'hive/config/LOAD_COUNTRY_CONFIG';
export const CHANGE_ENV = 'hive/config/CHANGE_ENV';
export const ENVIRONMENT_CONFIG = global.ENV || {};



// WEBPACK FOOTER //
// ./src/core/state/config/constants.js